/**
 * Keeps the left-side thumbnail rail (product--thumbnail gallery layout) from
 * growing taller than the main product image, and shows a small scroll-down
 * arrow when there are more thumbnails than fit in that height.
 */
(function () {
  function setupGallery(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    var thumbSlider = gallery.querySelector('.thumbnail-slider');
    if (!viewer || !thumbSlider || thumbSlider.dataset.railReady) return;
    var list = thumbSlider.querySelector('.thumbnail-list');
    if (!list) return;
    thumbSlider.dataset.railReady = 'true';

    var arrow = document.createElement('button');
    arrow.type = 'button';
    arrow.className = 'thumbnail-rail__arrow';
    arrow.setAttribute('aria-label', 'Weitere Bilder anzeigen');
    arrow.innerHTML =
      '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 7l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    thumbSlider.appendChild(arrow);

    function syncOverflow() {
      var overflowing = list.scrollHeight > list.clientHeight + 2;
      var atBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
      thumbSlider.classList.toggle('thumbnail-slider--has-overflow', overflowing && !atBottom);
    }

    function syncHeight() {
      var height = viewer.getBoundingClientRect().height;
      if (height > 0) list.style.maxHeight = height + 'px';
      syncOverflow();
    }

    arrow.addEventListener('click', function () {
      list.scrollBy({ top: list.clientHeight * 0.8, behavior: 'smooth' });
    });

    list.addEventListener('scroll', syncOverflow, { passive: true });
    window.addEventListener('resize', syncHeight);

    if (window.ResizeObserver) {
      new ResizeObserver(syncHeight).observe(viewer);
    }

    viewer.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', syncHeight, { once: true });
    });

    syncHeight();
    setTimeout(syncHeight, 100);
    setTimeout(syncHeight, 500);
  }

  function init() {
    document.querySelectorAll('.product--thumbnail media-gallery').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
